<template>
<div v-if="value" style="position:relative">


    <div class="element-label">{{schema.label}}</div>

    <!-- Steps -->
    <div v-if="value && value.length > 1" style="display:flex;gap:6px;margin-bottom:6px;">
        <div v-for="(file, fileIndex) in value" @click="selectedFile = value[fileIndex]" v-ripple style="padding:2px 10px;background-color:#eee;border-radius:8px;cursor:pointer;user-select:none;border: solid 1px #ccc" :key="fileIndex">
            {{fileIndex + 1}}
        </div>
    </div>

    <div v-if="selectedFile" style="padding:5px;border:solid 1px #ccc;position:relative">

        <div style="position:absolute;right:0px;top:-35px;">
            <v-tooltip v-if="selectedFile" bottom>
                <template v-slot:activator="{ on }">
                    <div >
                        <a v-on="on" :href="selectedFile.url" target="_new" class="transparent">
                            <v-btn icon>
                                <v-icon>exit_to_app</v-icon>
                            </v-btn> 
                        </a>
                    </div>
                </template>
                <span>Open in New Tab</span>
            </v-tooltip>
        </div>

        <template v-if="hasImage">
            <img :src="selectedFile.url" style="width:100%"/>
        </template>
        <div v-else>
            <object :data="selectedFile.url" :type="selectedFile.type" style="height:500px;width:100%;max-height:100%">
                <a :href="selectedFile.url">Open {{schema.label}}</a>
            </object>  
        </div>
    </div>
</div>
</template>

<script>

 

export default {
    name: 'FileView',

    data() {
        return {
            selectedFile: null,
        }
    },

    components: {
        
    },
    
    props: {
        value: Array,
        schema: Object, 
    },

    computed: {
        hasImage() {
            if(!this.selectedFile)
                return false

            return this.selectedFile.type.contains('image') 
                || this.selectedFile.url.contains('.jpg')
                || this.selectedFile.url.contains('.png')
                || this.selectedFile.url.contains('.gif')

        },
    },

    methods: {

    },

    created() {
        
    },

    watch: {
        'value': {
            handler: function(newVal) {    
                if(newVal && newVal.length)
                    this.selectedFile = this.value[0]
                else
                    this.selectedFile = null
            },
            immediate: true,
            deep: true,
        }
    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// FileView.vue?5517cf63